import { DocProperty } from 'typescript-openapi-router';

export class UpdateUserPreferLangResponseBody {
  @DocProperty({
    type: 'string',
    isRequired: true
  })
  preferLanguage?: string;
}
